import { SendCodePageSetting } from 'modules/auth/src/Event/SendCodePageSetting';

export default class AuthModel {
    phone: string;

    email: string;

    firstName: string;

    lastName: string;

    hash: string;

    isConfirmed: boolean;

    sendCodePageSetting: SendCodePageSetting;

}
